import script from "./DoctorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorInfo.vue?vue&type=script&setup=true&lang=js"

import "./DoctorInfo.vue?vue&type=style&index=0&id=5b105312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b105312"]])

export default __exports__